import Backdrop from "@mui/material/Backdrop";
import { Box, CircularProgress } from "@mui/material";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { memo } from "react";

const ModalWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 35px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .topContent": {
    marginBottom: "30px",
  },
  "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
  "& p": { fontSize: "16px", marginBottom: "8px", color: theme.palette.text.primary },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& .deleteLoader": {
      width: "28px !important",
      height: "28px !important",
      "& span": {
        width: "28px",
        height: "28px",
      },
      "& svg": {
        width: "",
        fill: "#fff",
        color: "#fff",
      },
    },
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "155.8px",
      "&:focus": {
        outline: "none",
      },
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.dark,
          color: "#fff",
        },
      },
    },
  },
}));

function ComfiramationPopup({ open, setOpen, onSubmit, loading, heading, subHeading, buttonText, cancelButtonText }) {
  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    if (onSubmit) onSubmit();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <ModalWrapper>
          <Box className="topContent">
            <Typography component="h4">{heading}</Typography>
            <Typography component="p">{subHeading}</Typography>
          </Box>
          <Box className="BtnWrapper">
            <Button disabled={loading} onClick={handleSubmit}>
              {" "}
              {loading ? <CircularProgress className="deleteLoader" /> : buttonText || "Delete"}
            </Button>
            <Button className="OutlineBtn" onClick={handleClose}>
              {cancelButtonText || "Cancel"}
            </Button>
          </Box>
        </ModalWrapper>
      </Fade>
    </Modal>
  );
}

export default memo(ComfiramationPopup);
